module.exports = __webpack_public_path__ + "static/Software-Engineer-7baef7ee054b9bce7c69528447513737.png";